// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI, { MessageBox } from 'element-ui'
import axios from 'axios';
import mavonEditor from 'mavon-editor'
import '@/style/common.css'
import 'mavon-editor/dist/css/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import animated from 'animate.css'
import store from './store'//引入store
import VCharts from 'v-charts'
import VideoPlayer from 'vue-video-player'
import './theme/index.css'  //修改默认主题
import "tailwindcss/tailwind.css";

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

// 引入全局组件
import commonBtn from '@/components/commonBtn.vue';
import commonDialog from '@/components/commonDialog.vue';
Vue.component('common-btn',commonBtn)
Vue.component('common-dialog',commonDialog)
// 引入全局配置
import theme from './config/theme';
Vue.prototype.$theme = theme;
import common from './config/common';
Vue.prototype.$common = common;


Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.use(mavonEditor)
Vue.use(VCharts)
Vue.use(animated)//使用animate动画
//把axios 挂载到vue的原型
Vue.prototype.$axios = axios;
// Vue.prototype.$axios = axios.create({
//   baseURL: 'https://admin.congraedu.cn'
//   // baseURL: 'http://172.168.1.60:7001'
// })
axios.interceptors.request.use(
  config => {

    let token = localStorage.getItem('token');
    // console.log(token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  },
)

router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    return next()
  }
  if (!localStorage.getItem('token')) {
    return next('/login')
  } else {
    next()
  }
  // ...
})

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // res是响应的结果
    // console.log('响应拦截器：', response.data)
    if (response.data.code == 401) {
      MessageBox.alert('登录信息超时，请重新登录！', '登录超时', {
        confirmButtonText: "跳转登录页面",
        callback: action => {
          router.push('/login')
        }
      })
    }
    // switch (response.data.code) {
    //   case 401:
    //     // 登录失效
    //     // 响应成功的拦截
    //     // console.log(response.data)
    //     // this.$router.push({ path: "/" });
    //     // this.$message.error(response.data.msg)
    //     window.location.href = "/"

    //     break
    //   default:
    //     return response
    // }
    return response
  },
  err => {
    // console.log(err.response);
    return Promise.resolve(err.response)
  }
)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js